class DropAHint extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.trigger = this.querySelector('.drop-a-hint__trigger');
    this.panel = this.querySelector('.drop-a-hint__panel');
    this.closeButton = this.querySelector('.drop-a-hint__close');
    this.status = this.querySelector('.drop-a-hint__status');

    const title = this.dataset.productTitle;
    const url = this.dataset.productUrl;
    const message = `Check out this item from H Williams Jewellery! ${title}: ${url}`;

    this.querySelector('[data-hint-action="text"]').href = `sms:?&body=${encodeURIComponent(message)}`;
    this.querySelector('[data-hint-action="email"]').href =
      `mailto:?subject=${encodeURIComponent(`A hint from H. Williams Jewellery: ${title}`)}&body=${encodeURIComponent(message)}`;
    this.querySelector('[data-hint-action="whatsapp"]').href =
      `https://wa.me/?text=${encodeURIComponent(message)}`;
    this.querySelector('[data-hint-action="facebook"]').href =
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

    this.trigger.addEventListener('click', () => this.toggle());
    this.closeButton.addEventListener('click', () => this.close());
    this.querySelector('[data-hint-action="copy"]').addEventListener('click', () => this.copy(url));
    this.querySelector('[data-hint-action="share"]').addEventListener('click', () => this.share(title, url));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
    document.addEventListener('click', (event) => {
      if (!this.panel.hidden && !this.contains(event.target)) this.close();
    });
  }

  toggle() {
    this.panel.hidden ? this.open() : this.close();
  }

  open() {
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.closeButton.focus();
  }

  close() {
    if (this.panel.hidden) return;
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.status.textContent = '';
    this.trigger.focus();
  }

  async copy(url) {
    try {
      await navigator.clipboard.writeText(url);
      this.status.textContent = 'Link copied.';
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
      this.status.textContent = 'Link copied.';
    }
  }

  async share(title, url) {
    if (!navigator.share) {
      await this.copy(url);
      this.status.textContent = 'Link copied. Paste it into your favourite app.';
      return;
    }

    try {
      await navigator.share({ title, text: `Take a look at ${title}`, url });
      this.close();
    } catch (error) {
      if (error.name !== 'AbortError') this.status.textContent = 'Sharing is unavailable. Please copy the link instead.';
    }
  }
}

if (!customElements.get('drop-a-hint')) {
  customElements.define('drop-a-hint', DropAHint);
}
